<template>
    <div class="player-container__panel-top">
        <div v-if="props.channelNumber && isEnabledChannelNumber" class="player-container__panel-top-item player-container__panel-top-item_number">{{ props.channelNumber }}</div>
        <img
            v-if="props.channelImage && isEnabledChannelImage"
            class="player-container__panel-top-item player-container__panel-top-item_image"
            :src="props.channelImage"
            :alt="channelName"
            loading="lazy"
        >
        <div v-if="props.channelCallSign && isEnabledCallSign" class="player-container__panel-top-item player-container__panel-top-item_call-sign">{{ props.channelCallSign }}</div>
        <div v-if="isEnabledProgramName" class="player-container__panel-top-item player-container__panel-top-item_delimiter" />
        <div v-if="props.playItemName && isEnabledProgramName" class="player-container__panel-top-item player-container__panel-top-item_name">{{ props.playItemName }}</div>
    </div>
</template>

<script setup lang="ts">

    const { playerConfig } = useAppConfig();
    const isEnabledChannelNumber = playerConfig.topPanel.isEnabledChannelNumber;
    const isEnabledChannelImage = playerConfig.topPanel.isEnabledChannelImage;
    const isEnabledCallSign = playerConfig.topPanel.isEnabledCallSign;
    const isEnabledProgramName = playerConfig.topPanel.isEnabledProgramName;


    const props = defineProps({
        playItemName: {
            type: String,
            default: '',
            required: true
        },

        channelNumber: {
            type: Number,
            default: 0,
            required: true
        },

        channelImage: {
            type: String,
            default: '',
            required: true,
        },

        channelCallSign: {
            type: String,
            default: '',
            required: true
        },

        channelName: {
            type: String,
            default: '',
            required: true
        },

    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>